import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[16/10] mb-4">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 国产在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
      <div className="flex items-center gap-2 mb-2">
        <span className="px-2 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-800">
          {article.category === 'dianshiju' ? '电视剧' :
           article.category === 'dianying' ? '电影' :
           article.category === 'zongyi' ? '综艺' :
           article.category === 'dongman' ? '动漫' : '短片'}
        </span>
        <span className="text-xs text-foreground-500">{article.date}</span>
      </div>
      <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
        {article.title}
      </h3>
      <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
        {article.excerpt}
      </p>
    </Link>
  );
}